module.exports = __webpack_public_path__ + "static/img/imageIco.f402034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/imageIco.png
// module id = Eu+s
// module chunks = 63